/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChunkQueueResponse
 */
export interface ChunkQueueResponse {
    /**
     * 
     * @type {string}
     * @memberof ChunkQueueResponse
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ChunkQueueResponse
     */
    jobId: string;
}

/**
 * Check if a given object implements the ChunkQueueResponse interface.
 */
export function instanceOfChunkQueueResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "jobId" in value;

    return isInstance;
}

export function ChunkQueueResponseFromJSON(json: any): ChunkQueueResponse {
    return ChunkQueueResponseFromJSONTyped(json, false);
}

export function ChunkQueueResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChunkQueueResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'jobId': json['jobId'],
    };
}

export function ChunkQueueResponseToJSON(value?: ChunkQueueResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'jobId': value.jobId,
    };
}

